<template>
    <div class="packaging-search">
        <div class="packaging-search__input-wrapper" :class="{ 'is-focused': isOpen }">
            <input
                    :class="{ 'is-focused': isOpen }"
                    type="text"
                    v-model="searchQuery"
                    @input="onInput"
                    placeholder="Поиск..."
                    class="packaging-search__input"
            />
            <span v-if="!searchQuery" class="packaging-search__search-icon">
                     <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                         <path d="M19.748 19.8792L23.8 23.7992M22.4933 13.3459C22.4933 18.3974 18.3982 22.4926 13.3466 22.4926C8.29505 22.4926 4.19995 18.3974 4.19995 13.3459C4.19995 8.29432 8.29505 4.19922 13.3466 4.19922C18.3982 4.19922 22.4933 8.29432 22.4933 13.3459Z"
                               stroke="#4B4A4A" stroke-width="2" stroke-linecap="round"/>
                     </svg>
                 </span>

            <button v-else @click="clearSearch" class="packaging-search__clear-button">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 7L7 21M21 21L7 7" stroke="#4B4A4A" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </button>

        </div>

        <ul v-if="isOpen" class="packaging-search__dropdown-list">
            <template v-if="filteredItems.length > 0">
                <li
                        v-for="(item, index) in filteredItems"
                        :key="index"
                        class="packaging-search__dropdown-item"
                >
                    <a :href="item.link" class="packaging-search__dropdown-link">
                        <img :src="item.image" alt="" class="packaging-search__dropdown-image" v-if="item.image"/>
                        <span class="packaging-search__dropdown__text">{{ item.name }}</span>
                    </a>
                </li>
            </template>

            <li v-else class="packaging-search__no-results packaging-search__dropdown-item">
                Товаров не найдено
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "packagingSearch",
    props: {
        products: Array | Object | Boolean | String,
    },
    data() {
        return {
            searchQuery: "",
            isOpen: false,
            debounceTimer: null,
            filteredItems: [],
            mockItems: this.products,

            /*mockItems: [
                {
                    name: "Пленка для запайки лотков",
                    image: "/upload/iblock/e58/uafdr1t1wuw76n6rwi5jyecw1oohdk6n/gibkaya_upakovka.jpg",
                    link: '/gibkaya-upakovka/plenka-dlya-zapayki-lotkov/',
                },
                {
                    name: "Пленка для барьерной упаковки",
                    image: "/upload/iblock/d8e/xso59ugmb1q31koiikamwjnpabtrwntx/zhestkaya_upakovka.jpg",
                    link: '/gibkaya-upakovka/plenka-dlya-barernoy-upakovki/',
                },
                {
                    name: "Пленка ламинированная",
                    image: "/upload/iblock/e15/5jm7hyg3623k5yn6yf4tyv36sb6i3m8d/Pakety_dlya_upakovki.jpg",
                    link: '/gibkaya-upakovka/plenka-laminirovannaya/',
                }
            ]*/
        }
    },
    beforeDestroy() {
        if (this.debounceTimer) clearTimeout(this.debounceTimer);
    },
    computed: {
        filteredItems() {
            const query = this.searchQuery.trim().toLowerCase();
            if (!query) return [];

            return this.mockItems.filter((item) =>
                item.name.toLowerCase().includes(query)
            );
        }
    },

    methods: {
        onInput() {
            const query = this.searchQuery.trim().toLowerCase();

            if (!query) {
                this.isOpen = false;
                this.filteredItems = [];
                if (this.debounceTimer) clearTimeout(this.debounceTimer);
                return;
            }

            if (this.debounceTimer) clearTimeout(this.debounceTimer);

            this.debounceTimer = setTimeout(() => {
                this.filteredItems = this.mockItems.filter((item) =>
                    item.name.toLowerCase().includes(query)
                );
                this.isOpen = true;
            }, 300);
        },
        clearSearch() {
            this.searchQuery = "";
            this.isOpen = false;
            this.filteredItems = [];
            if (this.debounceTimer) clearTimeout(this.debounceTimer);
        }
    }
}
</script>
<style lang="scss">
.catalog_page {
    .packaging-search__input-wrapper {
        max-width: 1920px !important;
        padding: 0 40px;
    }

    .packaging-search__input {
        max-width: 1920px !important;
    }

    .packaging-search__search-icon, .packaging-search__clear-button {
        right: 60px !important;
    }

}
</style>

<style scoped lang="scss">
.packaging-search {
  padding: 24px;
  border-radius: 40px;
  margin-bottom: 60px;

  &__input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    max-width: 800px;
    border-radius: 40px;
    background: #fff;
  }

  &__input {
    width: 100%;
    max-width: 800px;
    outline: none;
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 20px;
    line-height: 26px;
    letter-spacing: 0px;
    padding: 17px 20px;
    border: 2px solid #e6e6e6;
    border-radius: 40px;
    background: transparent;
    transition: border-color 0.2s ease-in-out;

    &:focus {
      border-color: #ff4738;
    }

    &.is-focused {
      border-color: #ff4738;
    }
  }

  &__search-icon,
  &__clear-button {
    position: absolute;
    top: 17px;
    right: 20px;
  }

  &__clear-button {
    background: none;
    border: none;
    font-size: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: #333;
    }
  }

  &__dropdown-list {
    position: absolute;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0.5px 1.5px 7px 0px #1A1A1A14;
    padding: 0;
    margin: 0 auto;
    list-style: none;
    max-height: 300px;
    max-width: 800px;
    width: 100%;
    overflow-y: auto;
    z-index: 1000;
    border: 1px solid #E1E1E2;
  }

  &__dropdown-item {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #F6F6F6;
    }
  }

  &__dropdown-link {
    display: flex;
    align-items: center;
  }

  &__dropdown-image {
    width: 100px;
    height: 70px;
    object-fit: contain;
    margin-right: 15px;
    flex-shrink: 0;
  }

  &__dropdown__text {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #121315;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__no-results {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 18px;
    line-height: 20px;
    letter-spacing: 0px;
    color: #121315;
  }
}

</style>